/**
 * WordPress dependencies
 */
import { createRoot } from '@wordpress/element';

/**
 * Internal dependencies
 */
import BookingsApp from './components/BookingsApp';

/**
 * Import styles
 */
import '../../css/bookings-app.css';
import '../../css/bookings-list.css';
import '../../css/pagination.css';


// Mount the React app
document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('nemtly-booking-bookings-app');

    // Only render if the container exists
    if (container) {
        const root = createRoot(container);
        root.render(<BookingsApp />);
    }
}); 